<template>
  <div class="container-detail">
    <div class="detail-header-buttons">
      <div class="container-main-header-button">
        <!-- <v-icon @click="back">mdi-chevron-left</v-icon> -->
        <v-btn depressed @click="back">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <span>Модерация профиля</span>
      </div>
    </div>
    <div class="detail-sub-header" v-if="item.moderationStatus === 'auto'">
      Профиль прошел автоматическую модерацию
    </div>
    <div class="detail-main-container">
      <div class="main-container-image">
        <img v-if="item.photo" :src="item.photo" />
        <div v-else><v-icon size="50px">mdi-account</v-icon></div>
      </div>
      <div class="main-container-block">
        <div class="container-block-item">
          <div class="block-item-title">ФИО</div>
          <div class="block-item-value">
            {{ item.lastName }} {{ item.firstName }} {{ item.middleName }}
          </div>
        </div>
        <div class="container-block-item">
          <div class="block-item-title">Телефон</div>
          <div class="block-item-value">
            {{ item.phoneNumber }}
          </div>
        </div>
        <div class="container-block-item">
          <div class="block-item-title">Эл. почта</div>
          <div class="block-item-value">
            {{ item.email }}
          </div>
        </div>
        <!--    <div class="container-block-item">
          <div class="block-item-title">Модерация</div>
          <div class="block-item-value">
            <span v-if="item.moderationStatus == 'passed'"> Пройдена</span>
            <span v-if="item.moderationStatus == 'pending'"> Ожидание</span>
            <span v-if="item.moderationStatus == 'refused'"> Отклонена</span>
          </div>
        </div> -->
      </div>

      <!-- <div class="main-container-block">
        <div class="container-block-item">
          <div class="block-item-title">ID пользователя</div>
          <div class="block-item-value">
            {{ item.id }}
          </div>
        </div>
        <div class="container-block-item">
                    <div class="block-item-title">
                        ID устройства
                    </div>
                    <div class="block-item-value">
                         {{item.accountId}} 
                    </div>
                </div>
        <div class="container-block-item">
          <div class="block-item-title">Дата регистрации</div>
          <div class="block-item-value">
            {{ item.dateCreated | moment("DD.MM.YYYY HH:mm") }}
          </div>
        </div>
        <div class="container-block-item">
          <div class="block-item-title">Дата последней активности</div>
          <div class="block-item-value">
            {{ item.lastActivity | moment("DD.MM.YYYY HH:mm") }}
          </div>
        </div>
      </div> -->
    </div>

    <div class="main-body-user-club-shareholders">
      <div class="body-inputs">
        <div class="container-block-title">
          Параметры отображения пользователя
        </div>

        <div class="switch-item-shareholder">
          <v-switch
            hide-details
            v-model="item.isKsaMember"
            color="var(--app-green-1)"
          ></v-switch>
          <div class="ditem-title">Участник КСА</div>
        </div>

        <div class="switch-item-shareholder">
          <v-switch
            hide-details
            v-model="item.isCandidate"
            color="var(--app-green-1)"
          ></v-switch>
          <div class="ditem-title">Кандидат КСА</div>
        </div>
        <div class="container-block-title">Параметры дополнительные</div>
        <div class="switch-item-shareholder">
          <v-switch
            hide-details
            v-model="item.isBankEmployee"
            color="var(--app-green-1)"
          ></v-switch>
          <div class="ditem-title">Сотрудник ВТБ</div>
        </div>
        <div>
          <v-text-field
            v-if="item.isBankEmployee || item.isKsaMember"
            label="Должность сотрудника"
            required
            type="text"
            outlined
            v-model="item.position"
          ></v-text-field>
        </div>
      </div>
    </div>
    <div class="butttons-bottom">
      <v-btn
        v-if="
          item.moderationStatus == 'pending' || item.moderationStatus == 'auto'
        "
        :disabled="loading"
        style="width: 120px !important"
        @click="moderationCompleted"
        color="var(--app-green-1)"
        class="button-accept-outlined"
        outlined
      >
        Подтвердить
      </v-btn>
      <v-btn
        v-else
        :disabled="loading"
        style="width: 120px !important"
        @click="saveEditItem"
        color="var(--app-green-1)"
        class="button-accept-outlined"
        outlined
      >
        Сохранить
      </v-btn>
      <v-btn
        v-if="item.moderationStatus == 'passed' && !item.isBlocked"
        outlined
        :disabled="loading"
        @click="dialogReasonBlock = true"
        style="width: auto !important"
        color="var(--app-red-1)"
        class="button-accept-outlined"
      >
        Заблокировать
      </v-btn>
      <v-btn
        :disabled="loading"
        v-if="
          item.moderationStatus == 'pending' || item.moderationStatus == 'auto'
        "
        outlined
        @click="dialogReason = true"
        style="width: auto !important"
        color="var(--app-red-1)"
        class="button-accept-outlined"
      >
        Отклонить
      </v-btn>
      <v-btn
        :disabled="loading"
        v-if="item.isBlocked"
        outlined
        @click="blockingUser(false)"
        style="width: auto !important"
        color="var(--app-red-1)"
        class="button-accept-outlined"
      >
        Разблокировать
      </v-btn>
    </div>
    <v-dialog
      :width="item.status != 'moderation' ? '500px' : '910px'"
      height="auto"
      persistent
      v-model="dialog"
    >
      <v-card
        :width="item.status != 'moderation' ? '500px' : '910px'"
        height="auto"
        class="rounded-0"
      >
        <v-form ref="formFirst">
          <v-card-title class="dialog-title">
            <span v-if="item.status == 'blocked'" class="title">Профиль</span>
            <span v-else class="title">Модерация профиля</span>
            <v-icon @click="closeDialog">mdi-close</v-icon>
          </v-card-title>
          <v-card-text
            class="dialog-description"
            v-if="item.status == 'completed'"
          >
            <div
              class="dialog-description-image d-flex align-center justify-center"
            >
              <img
                src="https://st2.depositphotos.com/1743476/11581/i/600/depositphotos_115812486-stock-photo-pride-man-smiling.jpg"
              />
            </div>
            <div class="dialog-item">
              <div class="ditem-title">ФИО</div>
              <div class="ditem-value">
                {{ item.name }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">Телефон</div>
              <div class="ditem-value">
                {{ item.phoneNumber }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">Эл. почта</div>
              <div class="ditem-value">
                {{ item.email }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">ID пользователя</div>
              <div class="ditem-value">
                {{ item.id }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">Дата регистрации</div>
              <div class="ditem-value">
                {{ item.dateCreated }}
              </div>
            </div>
            <div class="dialog-item">
              <div class="ditem-title">
                Дата последней <br />
                активности
              </div>
              <div class="ditem-value">
                {{ item.dateLast }}
              </div>
            </div>
          </v-card-text>

          <v-card-text
            v-if="item.status == 'moderation'"
            style="padding: 0px !important"
          >
            <div class="d-flex">
              <div
                class="pa-6"
                style="border-right: 1px solid rgb(0, 0, 0, 0.4)"
              >
                <div class="dialog-description-subtitle">
                  Новый пользователь
                </div>
                <div class="dialog-description-image d-flex align-center">
                  <img
                    src="https://st2.depositphotos.com/1743476/11581/i/600/depositphotos_115812486-stock-photo-pride-man-smiling.jpg"
                  />
                </div>
                <div class="dialog-item">
                  <div
                    class="ditem-title d-flex justify-space-between align-start"
                  >
                    ФИО
                    <v-icon class="mr-3" color="var(--app-orange-1)"
                      >mdi-alert</v-icon
                    >
                  </div>
                  <div class="ditem-value">
                    {{ item.name }}
                  </div>
                </div>
                <div class="dialog-item">
                  <div
                    class="ditem-title d-flex justify-space-between align-start"
                  >
                    Телефон
                    <v-icon class="mr-3" color="var(--app-orange-1)"
                      >mdi-alert</v-icon
                    >
                  </div>
                  <div class="ditem-value">
                    {{ item.phoneNumber }}
                  </div>
                </div>
                <div class="dialog-item">
                  <div
                    class="ditem-title d-flex justify-space-between align-start"
                  >
                    Эл. почта
                    <v-icon class="mr-3" color="var(--app-orange-1)"
                      >mdi-alert</v-icon
                    >
                  </div>
                  <div class="ditem-value">
                    {{ item.email }}
                  </div>
                </div>
              </div>
              <div class="pa-6">
                <div class="dialog-description-subtitle">Сотрудник банка</div>
                <div class="dialog-description-image d-flex align-center">
                  <img
                    src="https://st2.depositphotos.com/1743476/11581/i/600/depositphotos_115812486-stock-photo-pride-man-smiling.jpg"
                  />
                </div>
                <div class="dialog-item">
                  <div class="ditem-title">ФИО</div>
                  <div class="ditem-value">
                    {{ item.name }}
                  </div>
                </div>
                <div class="dialog-item">
                  <div class="ditem-title">Телефон</div>
                  <div class="ditem-value">
                    {{ item.phoneNumber }}
                  </div>
                </div>
                <div class="dialog-item">
                  <div class="ditem-title">Эл. почта</div>
                  <div class="ditem-value">
                    {{ item.email }}
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>

          <v-card-actions
            style="width: 50%; border-right: 1px solid rgb(0, 0, 0, 0.4)"
            class="dialog-buttons"
            v-if="item.status == 'moderation'"
          >
            <v-btn
              :disabled="loading"
              @click="dialogReason = true"
              outlined
              style="width: 120px !important"
              color="var(--app-red-1)"
              class="button-accept-outlined"
            >
              Отклонить
            </v-btn>
            <v-btn
              :disabled="loading"
              style="width: 120px !important"
              @click="closeDialog"
              color="var(--app-green-1)"
              class="button-accept-outlined"
              outlined
            >
              Принять
            </v-btn>
          </v-card-actions>

          <v-card-actions class="dialog-buttons justify-end" v-else>
            <v-btn
              @click="closeDialog"
              outlined
              style="width: auto !important"
              color="var(--app-red-1)"
              class="button-accept-outlined"
            >
              Заблокировать
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog width="570px" height="auto" persistent v-model="dialogReason">
      <v-card width="570px" height="auto" class="rounded-0">
        <v-form ref="formSecondCancel">
          <v-card-title class="dialog-title">
            <span class="title">Причина отклонения</span>

            <v-icon @click="dialogReason = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <v-select
              :items="reasons"
              outlined
              item-text="text"
              item-value="id"
              :rules="[(v) => !!(v && v.length) || 'Обязательно к заполнению']"
              label="Выберите причину"
              v-model="item.reasonCancelUser"
            ></v-select>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn
              :disabled="loading"
              @click="dialogReason = false"
              outlined
              style="width: 120px !important"
              color="var(--app-red-1)"
              class="button-accept-outlined"
            >
              Отклонить
            </v-btn>
            <v-btn
              :disabled="loading"
              style="width: 120px !important"
              @click="cancelModerationkUser"
              color="var(--app-green-1)"
              class="button-accept-outlined"
              outlined
            >
              Принять
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      width="570px"
      height="auto"
      persistent
      v-model="dialogReasonBlock"
    >
      <v-card width="570px" height="auto" class="rounded-0">
        <v-form ref="formSecond">
          <v-card-title class="dialog-title">
            <span class="title">Причина блокировки</span>

            <v-icon @click="dialogReasonBlock = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <v-select
              :items="reasonsBlock"
              outlined
              item-text="title"
              item-value="id"
              :rules="[(v) => !!(v && v.length) || 'Обязательно к заполнению']"
              v-model="item.reasonBlock"
              label="Выберите причину"
            ></v-select>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn
              :disabled="loading"
              @click="dialogReasonBlock = false"
              outlined
              style="width: 120px !important"
              color="var(--app-green-1)"
              class="button-accept-outlined"
            >
              Отмена
            </v-btn>
            <v-btn
              :disabled="loading"
              style="width: 120px !important"
              color="var(--app-red-1)"
              @click="blockingUser(true)"
              class="button-accept-outlined"
              outlined
            >
              Блокировка
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data: () => ({
    reasons: [],
    items: [],
    tableHeaders: [
      {
        text: "ФИО",
        sortable: false,
        value: "name",
      },
      {
        text: "Последняя активность",
        value: "date",
        sortable: false,
      },
      {
        text: "ID",

        sortable: false,
        value: "id",
      },
    ],
    dialog: false,
    dialogReason: false,
    dialogReasonBlock: false,
    item: {},
    loading: false,
    reasonsBlock: [],
  }),
  methods: {
    closeDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.$refs.formFirst.reset();
        this.item = {};
      }, 100);
    },
    openDialog(item) {
      this.item = Object.assign({}, item);
      this.dialog = true;
    },
    back() {
      this.$router.push({ name: "ChatUsers" });
    },
    getItem() {
      this.$axios
        .post(this.$store.getters.apiAdminPanelV5 + "/user", null, {
          params: { userId: this.$route.params.id },
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
        })
        .then((res) => {
          this.item = res.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getReasonsBlocks() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/club/blocking/reason/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.reasonsBlock = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    blockingUser(item) {
      if (item ? this.$refs.formSecond.validate() : true) {
        this.loading = true;
        this.$axios
          .post(
            this.$store.getters.apiAdminPanelV2 + "/club/user/blocking",
            {
              toBlock: item,
              userId: this.item.id,
              reasonId: item ? this.item.reasonBlock : "",
            },
            {
              headers: {
                authorization: this.$store.getters.adminPanelHeaderAuth,
              },
            }
          )
          .then(() => {
            this.dialogReasonBlock = false;
            this.getItem();
            this.loading = false;
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
      }
    },
    getReasons() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 +
            "/club/moderation/refuse/reason/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.reasons = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    cancelModerationkUser() {
      if (this.$refs.formSecondCancel.validate()) {
        this.loading = true;
        this.$axios
          .post(
            this.$store.getters.apiAdminPanelV2 + "/club/user/moderation",
            {
              moderationStatus: "refused",
              userId: this.item.id,
              reasonId: this.item.reasonCancelUser,
            },
            {
              headers: {
                authorization: this.$store.getters.adminPanelHeaderAuth,
              },
            }
          )
          .then(() => {
            this.loading = false;
            this.dialogReason = false;
            this.$router.push({ name: "ChatUsers" });
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
            this.loading = false;
          });
      }
    },
    moderationCompleted() {
      this.loading = true;
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/club/user/moderation",
          {
            moderationStatus: "passed",
            userId: this.item.id,
            isBankEmployee: this.item.isBankEmployee,
            isKsaMember: this.item.isKsaMember,
            isCandidate: this.item.isCandidate,
            position: this.item.position,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => {
          this.dialog = false;
          this.getItem();
          this.loading = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    saveEditItem() {
      this.loading = true;
      this.$axios
        .patch(
          this.$store.getters.apiAdminPanelV5 +
            `/user/${this.$route.params.id}`,
          {
            isBankEmployee: !!this.item.isBankEmployee,
            isKsaMember: !!this.item.isKsaMember,
            isCandidate: !!this.item.isCandidate,
            position:
              !this.item.isBankEmployee && !this.item.isKsaMember
                ? ""
                : this.item.position,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.dialog = false;
          this.getItem();
          this.loading = false;
          this.$store.commit("errorSet", {
            key: true,
            text: "Данные сохранены",
            type: "success",
          });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
          this.loading = false;
        });
    },
  },
  created() {
    this.getItem();
    this.getReasonsBlocks();
    this.getReasons();
  },
};
</script>
<style lang="scss" scoped>
.container-detail {
  height: 100%;
  box-sizing: border-box;

  .detail-header-buttons {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    padding: 40px 40px 0px 40px;

    .container-main-header-button {
      display: flex;
      align-items: center;

      span {
        font-size: 28px;
        font-weight: 400;
        margin-left: 16px;
      }
    }
  }

  .detail-sub-header {
    background: RGB(37, 175, 41, 0.2);
    color: var(--app-green-1);
    font-size: 16px;
    font-weight: 400;
    padding: 0px 40px 0px 40px;
    height: 52px;
    display: flex;
    align-items: center;
  }

  .detail-main-container {
    display: flex;
    padding: 32px 40px 0px 40px;

    .main-container-image {
      img {
        width: 261px;
        height: 286px;
        object-fit: cover;
      }

      div {
        width: 190px;
        height: 210px;
        background: #d8d8d8;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .main-container-block {
      margin: 0 40px;

      .container-block-item {
        display: flex;
        flex-direction: column;
        margin-bottom: 24px;

        .block-item-title {
          color: rgba(0, 0, 0, 1);
          font-size: 24px;
          font-weight: 600;
          font-style: normal;
          letter-spacing: 0px;
          text-align: left;
        }

        .block-item-value {
          color: rgba(0, 0, 0, 1);
          font-size: 18px;
          font-weight: 400;
          font-style: normal;
          letter-spacing: 0px;
          text-align: left;
        }
      }
    }
  }

  .detail-subtitle {
    font-size: 24px;
    font-weight: 600;
    margin: 24px 0;
  }

  .main-body-user-club-shareholders {
    width: 100%;
    padding: 0px 40px 0px 40px;

    .body-inputs {
      width: 70%;

      .container-block-title {
        margin-top: 32px;
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 16px;
      }

      .switch-item-shareholder {
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }
    }
  }

  .butttons-bottom {
    width: 70%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    padding: 40px 15px 40px 40px;
  }
}

.dialog-description-image {
  margin-bottom: 20px;

  img {
    width: 190px;
    height: 208px;
    object-fit: cover;
  }
}

.dialog-description-subtitle {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 18px;
}
</style>
